var map = {
	"./ar.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/ar.js",
		1050
	],
	"./bg.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/bg.js",
		1051
	],
	"./ca.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/ca.js",
		0,
		1052
	],
	"./cs.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/cs.js",
		0,
		1,
		1053
	],
	"./da.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/da.js",
		1054
	],
	"./de.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/de.js",
		1055
	],
	"./en-gb.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/en-gb.js",
		1056
	],
	"./es-do.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/es-do.js",
		0,
		1057
	],
	"./es-us.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/es-us.js",
		0,
		1058
	],
	"./es.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/es.js",
		0,
		1059
	],
	"./et.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/et.js",
		1060
	],
	"./fi.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/fi.js",
		1061
	],
	"./fr.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/fr.js",
		1062
	],
	"./gl.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/gl.js",
		0,
		1063
	],
	"./he.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/he.js",
		1064
	],
	"./hi.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/hi.js",
		1065
	],
	"./hu.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/hu.js",
		0,
		1,
		1066
	],
	"./id.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/id.js",
		1067
	],
	"./it.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/it.js",
		0,
		1,
		1068
	],
	"./ja.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/ja.js",
		1069
	],
	"./ko.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/ko.js",
		1070
	],
	"./lt.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/lt.js",
		1071
	],
	"./mn.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/mn.js",
		1072
	],
	"./nb.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/nb.js",
		1073
	],
	"./nl-be.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/nl-be.js",
		0,
		1074
	],
	"./nl.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/nl.js",
		0,
		1075
	],
	"./pl.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/pl.js",
		0,
		1,
		1076
	],
	"./pt-br.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/pt-br.js",
		0,
		1,
		1077
	],
	"./ro.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/ro.js",
		1078
	],
	"./ru.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/ru.js",
		0,
		1,
		1079
	],
	"./sk.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/sk.js",
		0,
		1,
		1080
	],
	"./sl.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/sl.js",
		0,
		1,
		1081
	],
	"./sv.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/sv.js",
		1082
	],
	"./th.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/th.js",
		1083
	],
	"./tr.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/tr.js",
		1084
	],
	"./vi.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/vi.js",
		1085
	],
	"./zh-cn.js": [
		"./node_modules/ngx-bootstrap/chronos/esm5/i18n/zh-cn.js",
		1086
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./node_modules/ngx-bootstrap/chronos/esm5/i18n lazy recursive ^\\.\\/.*\\.js$";
module.exports = webpackAsyncContext;